import CBAA1010RequestModel from '@/api/data/CBA/CBAG1010/CBAA1010RequestModel'
import CBAA1010ResponseModel from '@/api/data/CBA/CBAG1010/CBAA1010ResponseModel'

import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'

export default class CBAG1010Service {
  /**
   * CBAA1010 API処理呼出
   * @returns Response CBAG1010
   */
  public async callAPICBAA1010(): Promise<CBAA1010ResponseModel> {
    const cbaa1010RequestModel = new CBAA1010RequestModel()
    const cbaa1010ResponseModel: CBAA1010ResponseModel = <
      CBAA1010ResponseModel
    > await RestService.post(ApiUrlConstants.CBAA1010, cbaa1010RequestModel)

    return cbaa1010ResponseModel
  }
}
